import { useAtom } from 'jotai';
import { useRouter } from 'next/router';
import type { Dispatch, SetStateAction } from 'react';
import { useEffect } from 'react';

import type { WebinarDto } from '@/api/webinar';
import { useWebinarUser } from '@/hooks/react-query/webinar';
import { parseDate } from '@/lib/utils/businessLogics/utils/_helper';
import { sendLog } from '@/lib/utils/send-log';
import { padZero } from '@/pages/plus/shared/components/Landing/Timer/logic';
import { MobileGNBOpenAtom } from '@/store/landing';
import { useLoginModal } from '@/store/login';

import * as S from './WebinarFloatingCta.style';

type WebinarFloatingCta = {
  webinar: WebinarDto;
  onlineUserId: string;
  showApplicationModal: boolean;
  setShowApplicationModal: Dispatch<SetStateAction<boolean>>;
};
export default function WebinarFloatingCta({
  webinar,
  onlineUserId,
  showApplicationModal,
  setShowApplicationModal,
}: WebinarFloatingCta) {
  const loginModal = useLoginModal();

  const { webinarUser, isLoading } = useWebinarUser(webinar._id, onlineUserId);
  const webinarDate = new Date(webinar.video.broadcastedAt);
  webinarDate.setHours(webinarDate.getHours() - 9);
  const { month, day, hour, dayOfWeek } = parseDate(webinarDate);
  const webinarDateTime = `
  ${month}/${day}(${dayOfWeek}) 저녁 ${Number(padZero(hour)) - 12}시 LIVE
  `;
  const router = useRouter();
  const [isMobileGnbOpen] = useAtom(MobileGNBOpenAtom);

  function handleClickCtaBtn() {
    if (!onlineUserId) {
      loginModal.open(`${router.asPath}?action=applyWebinar`);
      return;
    }
    sendLog('hh_webinarDetailPage_applynow_click', {
      webinar_name: webinar.video.title,
      webinar_speaker: webinar.lecturer.name,
      webinar_date: webinar.video.broadcastedAt,
    });
    setShowApplicationModal(true);
  }

  useEffect(() => {
    if (router.query['action'] === 'applyWebinar') {
      if (isLoading) {
        return;
      }

      if (!webinarUser?.orientation?.applied) {
        setShowApplicationModal(true);
        const { action, ...remainingQueries } = router.query;
        void action;

        router.replace(
          {
            pathname: router.pathname,
            query: remainingQueries,
          },
          undefined,
          { shallow: true },
        );
      }
    }
  }, [isLoading]);

  return (
    <>
      <S.Wrapper hideFloating={showApplicationModal || isMobileGnbOpen}>
        <S.Container>
          <S.WebinarInfo>
            <S.Lecturer>{webinarDateTime}</S.Lecturer>
            <S.DateTime>합격 이력서, 면접 족보 제공!</S.DateTime>
          </S.WebinarInfo>
          <S.ApplyBtn
            disabled={webinarUser?.orientation.applied}
            onClick={handleClickCtaBtn}
          >
            {webinarUser?.orientation.applied ? '신청 완료' : '무료 신청하기'}
          </S.ApplyBtn>
        </S.Container>
      </S.Wrapper>
    </>
  );
}
